import { useEffect, useRef, useState } from 'react'

const THINKING_MESSAGES = [
  'Thinking...',
  'Browsing the catalog...',
  'Tracing the DQL...',
  'Reasoning about your blueprint...',
  'Composing the purpose...',
  'Considering presentation options...',
  'Wrangling some data...',
  'Checking the schema...',
  'Considering edge cases...',
  'Running the numbers...',
  'Connecting the dots...',
  'Reviewing the plan...',
  'Almost there...'
]

const ROTATION_INTERVAL_MS = 3000

export function useRotatingMessage (active, override) {
  const [index, setIndex] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (!active || override) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
      setIndex(0)
      return
    }

    intervalRef.current = setInterval(() => {
      setIndex(prev => (prev + 1) % THINKING_MESSAGES.length)
    }, ROTATION_INTERVAL_MS)

    return () => clearInterval(intervalRef.current)
  }, [active, override])

  if (!active) return null
  if (override) return override
  return THINKING_MESSAGES[index]
}
